// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBusinessOilWell = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4.133 6.027c.614-1.73 1.525-3.192 2.488-4.12a.449.449 0 0 1 .471-.095l2.378.887a.5.5 0 0 1 .285.638l-1.167 3.29 1.975.737A1.86 1.86 0 0 1 11.667 7h.06c.891 0 1.641.634 1.857 1.492l5.544 2.07a.5.5 0 0 1 .285.638l-.334.942a.493.493 0 0 1-.315.308V19h.25a.49.49 0 0 1 .48.5v1a.49.49 0 0 1-.48.5H4.38a.49.49 0 0 1-.48-.5v-1c0-.276.215-.5.48-.5h12.923v-6.991l-3.31-1.236L15.596 19h-1.95l-.536-2.75h-2.826L9.746 19h-1.95l1.916-9.825-1.791-.669-1.168 3.29a.48.48 0 0 1-.618.3l-2.377-.888a.467.467 0 0 1-.302-.383c-.156-1.346.062-3.067.676-4.798zm6.443 8.723h2.242l-.738-3.784a1.86 1.86 0 0 1-.354.034h-.059c-.12 0-.239-.012-.353-.034zM8.067 3.769l-.873-.326c-.633.75-1.255 1.821-1.71 3.104-.452 1.273-.646 2.493-.635 3.475l.883.33z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgBusinessOilWell;
